const HEX_SQRT3 = Math.sqrt(3);

export const getBattleEffectCellGeometry = (cell, gridType) => {
  if (gridType !== 'hex') {
    return { type: 'rect', x: cell.x, y: cell.y, width: 1, height: 1 };
  }

  const centerX = 1 + cell.x * 1.5;
  const centerY = HEX_SQRT3 / 2 + cell.y * HEX_SQRT3 + (cell.x % 2 === 1 ? HEX_SQRT3 / 2 : 0);
  const points = Array.from({ length: 6 }, (_, side) => {
    const angle = (Math.PI / 3) * side;
    return {
      x: centerX + Math.cos(angle),
      y: centerY + Math.sin(angle),
    };
  });

  return { type: 'polygon', points };
};

export const buildBattleEffectPathData = (cells = [], gridType) => (
  cells.map((cell) => {
    const geometry = getBattleEffectCellGeometry(cell, gridType);
    if (geometry.type === 'rect') {
      return `M ${geometry.x} ${geometry.y} h ${geometry.width} v ${geometry.height} h ${-geometry.width} Z`;
    }
    const [first, ...remaining] = geometry.points;
    return `M ${first.x} ${first.y} ${remaining.map(({ x, y }) => `L ${x} ${y}`).join(' ')} Z`;
  }).join(' ')
);